<template>
  <qx-card-form title="基础信息">
    <qx-custom-form :noSubBtn="true" ref="baseForm" :formData="baseForm" labelWidth="120px">
      <section slot="car" slot-scope="prop">
        <ChooseCar :isRadio="true" v-model="prop.form.car" />
      </section>
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
import {
  getDepartmentAllList,
  getEnumList,
} from 'api';
import {
  servicerSelectList,
} from 'api/service';
import ChooseCar from 'components/choose/car';
export default {
  components: {
    ChooseCar,
  },
  data () {
    return {
      baseForm: {
        stateOptions: [], // ETC状态
        xlCardTypeOptions: [], // 卡类型
        paymentTypeOptions: [], // 付费类型
        userIdOptions: [], // 服务商
        form: [
          {
            label: 'ETC卡号',
            value: 'etcId',
            type: 'input',
          },
          {
            label: '服务商',
            value: 'userId',
            type: 'select',
          },
          {
            label: 'ETC状态',
            value: 'state',
            type: 'select',
          },
          {
            label: '绑定车辆',
            value: 'car',
            default: {},
            slot: true,
          },
          {
            label: '卡类型',
            value: 'xlCardType',
            type: 'select',
          },
          {
            label: '付费类型',
            value: 'paymentType',
            type: 'select',
            onChange: () => {
              this.handlePaymentType();
            },
          },
          {
            label: '账期描述',
            value: 'accountPeriodRemark',
            type: 'input',
            hide: true,
          },
        ],
        rules: {
          etcId: [ // ETC卡号
            { required: true, message: '请输入ETC卡号', trigger: 'blur' },
          ],
          userId: [ // 服务商
            { required: true, message: '请选择服务商', trigger: 'blur' },
          ],
          state: [ // ETC状态
            { required: true, message: '请选择ETC状态', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {

    async getList () {
      this.baseForm.userIdOptions = await servicerSelectList({
        serviceType: 3,
      });
      this.baseForm.orgIdOptions = await getDepartmentAllList();
      const enumsList = await getEnumList({
        codeType: 'SYS_STATE_DESC,ETC_CARD_TYPE,ETC_SERVICE_PAYMENT_TYPE',
      });
      this.baseForm.stateOptions = enumsList[0];
      this.baseForm.xlCardTypeOptions = enumsList[1];
      this.baseForm.paymentTypeOptions = enumsList[2];
    },

    async handlePaymentType () {
      const paymentType = this.$refs.baseForm.getVal('paymentType');
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: paymentType !== '2',
        names: ['accountPeriodRemark'],
      });
    },

    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        formData.bindVehicle = formData.car.plateNumber;
        formData.xlVehicleStatus = formData.car.vehicleStatus;
        delete formData.car;
      }
      return formData;
    },
    async sub () {
      const formData = await this.handleSubData();
      if (formData) {
        formData.etcCardType = formData.xlCardType;
      }
      return formData;
    },
    async cacheData () {
      const res = await this.handleSubData(true);
      return res;
    },
    init (data = {}) {
      data.car = { // 绑定车辆
        plateNumber: data.bindVehicle,
        vehicleStatus: data.xlVehicleStatus,
      };
      if (data.state) { // ETC状态
        data.state = String(data.state);
      }
      if (data.xlCardType && data.xlCardType !== -1) { // 卡类型
        data.xlCardType = String(data.xlCardType);
      } else {
        data.xlCardType = '';
      }
      if (data.paymentType && data.paymentType !== -1) { // 付费类型
        data.paymentType = String(data.paymentType);
      } else {
        data.paymentType = '';
      }
      this.$refs.baseForm.setVal(data);
      this.handlePaymentType();
    },
  },
};
</script>

<style scoped lang="scss">
</style>
